import { Injectable, signal } from '@angular/core';
import { FilterDisplayOptions } from '@modules/filter/utils/filter-options';
import { CreateFilterOptions, FilterList, FilterRow } from '@type/filter.type';

@Injectable({
  providedIn: 'root',
})
export class FilterHelperService {
  options = signal(new FilterDisplayOptions());

  set(options: CreateFilterOptions) {
    this.options.set(
      Object.assign(options, {
        rows: options.rows.map((row) => ({
          ...row,
          fields: this.convertFields(row.fields, row.excludeFields),
        })),
        search: options.search ?? true,
      }),
    );
  }

  private convertFields(fields: FilterList, excludedField: string[] = []): FilterRow[] {
    return fields
      .filter(({ name }) => !excludedField.includes(name))
      .map((f) => ({
        id: f.id || 0,
        name: f.localized_name,
        localized_name: f.localized_name,
        model: f.name,
        type: f.field_type,
        dictionaryModel: f.dictionary_type || f.name,
      }));
  }
}
